export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDSBX5vX3ivXbPwy_Qe6odB_kR9Hcd9BAg",
    authDomain: "woodpecker-method.firebaseapp.com",
    projectId: "woodpecker-method",
    storageBucket: "woodpecker-method.firebasestorage.app",
    messagingSenderId: "348292288398",
    appId: "1:348292288398:web:5efaf1bc91c57be2721edf",
    measurementId: "G-TCTKS4TEV9"
  }
};


